module.exports = __webpack_public_path__ + "img/Logo1.aea68bd3.png";